import { PaletteMode } from "@mui/material";


declare module "@mui/material/styles" {
  interface Palette {
    backgroundv2: {
      switchLightBackground: string;
      button: string;
    };
  }
}

const ColorLightMode = (mode: PaletteMode) => ({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            // palette values for light mode
           backgroundv2:{switchLightBackground:'#8a9c90',button:"#01d28e"},
           
          }
        : {
            // palette values for dark mode
            backgroundv2:{switchLightBackground:'#3d453f',button:"#4af7bf"},
            divider:"#404040"
          }),
    },
    breakpoints:{
      values: {
        xs: 0,
        sm: 910,
        md: 1000,
        lg: 1200,
        xl: 1536,
      },
    }
  });
export default ColorLightMode;